import { getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import type { AuthProvider, Locale, UserProfile } from '@easymoving/types';
import { userDoc } from './paths';

/**
 * Create the users/{uid} profile doc if it doesn't exist yet. Called once on
 * sign-up / first social sign-in. Idempotent — a returning user keeps their
 * existing profile (we only patch `updatedAt`).
 */
export async function ensureUserProfile(input: {
  uid: string;
  email: string | null;
  name?: string | null;
  authProvider: AuthProvider;
  locale: Locale;
}): Promise<void> {
  const ref = userDoc(input.uid);
  const snap = await getDoc(ref);
  if (snap.exists()) {
    await setDoc(ref, { updatedAt: serverTimestamp() }, { merge: true });
    return;
  }
  await setDoc(ref, {
    uid: input.uid,
    email: input.email ?? '',
    name: input.name ?? '',
    authProvider: input.authProvider,
    locale: input.locale,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export async function getUserProfile(uid: string): Promise<UserProfile | null> {
  const snap = await getDoc(userDoc(uid));
  return snap.exists() ? (snap.data() as UserProfile) : null;
}
